import { LOGOUT } from './actionTypes/user';
import { reload } from './backendCommon';

type DispatchFn = (action: unknown) => unknown;

export const doLogout = () => (dispatch: DispatchFn) => {
    dispatch({
        type: LOGOUT
    });
    dispatch(
        reload({
            isImmediate: true,
            reason: 'LOGOUT',
            logout: true
        })
    );
};
